/**
 * Entidad ProductAttribute
 * Define los atributos disponibles que se pueden asignar a las variantes de producto (ej. Color, Talla).
 * Especifica el nombre y tipo del atributo para ayudar en la representación y filtrado.
 */

export interface ProductAttribute {
  id: string;
  accountId: string;
  name: string;  // e.g., "Color de zapatos", "Talle de pantalones", "Material"
  alias: string; // e.g., "Color", "Talla", "Material"
  slug: string;
  type: ProductAttributeType; // Helps frontend render appropriate controls
  isRequired: boolean; // isRequired for product variant
  suffix: string; // suffix for number type
  status: ProductAttributeStatus; // ACTIVE, INACTIVE
  createdAt: Date;
  updatedAt: Date;
  deletedAt?: Date | null;

  options: ProductAttributeOption[];
  displayOrder: number; // order to display the attribute in the frontend
}

export enum ProductAttributeStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}


export enum ProductAttributeType {
    TEXT = 'TEXT', // text input
    NUMBER = 'NUMBER', // number input
    COLOR = 'COLOR', // Special type for color swatches
    SELECT = 'SELECT', // Dropdown list
    BOOLEAN = 'BOOLEAN', // checkbox input
}

/**
 * Una opción específica para un atributo (ej. "Talle 42" para el atributo "Talle").
 */
export interface ProductAttributeOption {
  id: string;
  accountId: string;
  productAttributeId: string;
  value: string;
  imageId?: string | null;
  order: number;
  createdAt: Date;
  updatedAt: Date;
  deletedAt?: Date | null;

  count: number; // number of options
}